import * as React from "react";
import { Button, ButtonProps } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

interface IProps extends ButtonProps {
  children: React.ReactNode;
  to: string;
}

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.link,
    padding: 0,
    cursor: "default",
    "&.MuiButton-textPrimary:hover": {
      backgroundColor: "transparent",
    },
  },
  link: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
    margin: 0,
  },
}));

export const ButtonLink = ({ children, to, className }: IProps) => {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    history.push(to);
  };

  return (
    <Button
      color="primary"
      className={`${className} ${classes.button}`}
      component={Link}
      to={to}
      onClick={handleClick}
    >
      <div className={classes.link}>{children}</div>
    </Button>
  );
};
